<template>
  <div ref="stepper">
    <v-stepper v-model="localStepIndex" elevation="0" class="fullContent">
      <v-stepper-header>
        <template v-for="(v, k) in localSteps">
          <div
              :key="`${k}-step`"
              :class="'v-stepper__step'+(localStepIndex>k ? ' v-stepper__step--complete' : localStepIndex===k ? ' v-stepper__step--active' : '')"
          >
            <v-avatar v-if="localStepIndex>k" size="24" color="primary" class="mr-2">
              <v-icon color="white" size="18">mdi-check</v-icon>
            </v-avatar>
            <span v-else :class="'v-stepper__step__step'+(localStepIndex>=k ? ' primary' : '')">{{k+1}}</span>
            <div class="v-stepper__label">{{ v.name }}</div>
          </div>
          <v-divider v-if="k !== localSteps.length-1" :key="k"/>
        </template>
      </v-stepper-header>
    </v-stepper>
    <div v-for="(v, k) in localSteps" :key="`${k}-step-content`">
      <v-form
          :ref="'form_'+k"
          @submit.prevent="next(k)"
      >
        <div v-if="k===localStepIndex">
          <slot :index="k" :height="height-72-1-68" :width="width"/>
          <v-divider/>
          <div class="pa-4">
            <v-btn v-if="localStepIndex>0" text class="mr-2" @click="localStepIndex--">Назад</v-btn>
            <v-btn v-if="localStepIndex<localSteps.length-1" color="primary" depressed type="submit">Далее</v-btn>
            <div v-else class="d-inline-block">
              <slot name="completeButton"/>
            </div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  props:['stepIndex','steps','height'],
  data: () => ({
    localStepIndex:0,
    localSteps:[],
    width:0,
  }),
  mounted() {
    this.localStepIndex = this.stepIndex;
    this.localSteps = this.steps;
    this.resize();
    setTimeout(this.resize,250);
    setTimeout(this.resize,500);
    setTimeout(this.resize,1000);
    setTimeout(this.resize,2000);
    window.addEventListener('resize', this.resize, true);
  },
  watch:{
    stepIndex(){
      this.localStepIndex = this.stepIndex;
    },
    localStepIndex(){
      this.$emit('update:stepIndex', this.localStepIndex)
    },
    steps(){
      this.localSteps = this.steps;
    },
    localSteps(){
      this.$emit('update:steps', this.localSteps)
    }
  },
  methods:{
    resize(){
      if(!this.$tools.isDefined(this.$refs.stepper))
        return;
      this.width = this.$refs.stepper.getBoundingClientRect().width;
    },
    next(k){
      if (this.$refs['form_'+k][0].validate()){
        this.localStepIndex++
      }
    }
  }
}
</script>